var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('iframe',{attrs:{"src":_vm.url,"width":"100%","height":"100vh"}}):_c('div',{staticStyle:{"background":"white","padding":"20px"}},[_c('p',[_vm._v("Generating...")]),_c('p',[_vm._v("This usually takes about a 8 minutes.")])])}
var staticRenderFns = []

export { render, staticRenderFns }